<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<xizaokaList></xizaokaList>
		</div>
		<div class="add" v-if="type==='update'">
			<xizaokaUpdate></xizaokaUpdate>
			<div class="settlementBox">
				<xizaokaUpdateSettlement></xizaokaUpdateSettlement>
			</div>
		</div>
		<div class="add" v-if="type==='add'">
			<xizaokaAdd></xizaokaAdd>
			<div class="settlementBox">
				<xizaokaSettlement></xizaokaSettlement>
			</div>
		</div>
	</div>
</template>
<script>
	import xizaokaAdd from "./comp/xizaoka_add.vue"
	import xizaokaUpdate from "./comp/xizaoka_update.vue"
	import xizaokaList from "./comp/xizaoka_list.vue"
	import xizaokaSettlement from "./comp/xizaoka_settlement.vue"
	import xizaokaUpdateSettlement from "./comp/xizaokaUpdate_settlement.vue"
	export default {
		components:{xizaokaAdd,xizaokaUpdate,xizaokaList,xizaokaSettlement,xizaokaUpdateSettlement},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.xizaoka.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	background-color: #fff;
	.settlementBox{
		position: absolute;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
